<template>
    <div>
    
        <h1>Create New Tour Manager</h1>
    
        <div class="box">
    
          <Errors/>
    
          <form class="form" v-on:submit.prevent="createTourManager">
    
            <TourManagerFields />
    
            <div class="form-wrap form-submit">
              <div v-if="this.getLoadStatus">
                <button type="submit" class="button" disabled>Creating...</button>
              </div>
              <div v-else>
                <button type="submit" class="button">Create Tour Manager</button>
              </div>
            </div>
    
          </form>
    
        </div>
    
    </div>
    
    </template>
    
    <script>

    import TourManagerFields from '@/components/TourManagerFields.vue'

    import Errors from '@/components/Errors.vue'

    import {mapGetters} from 'vuex'

    export default {

      name: 'TourManagerCreate',
      
      computed: mapGetters(['getLoadStatus']),

      data () {
        return {
          tour_manage : {
            firstname: null,
            lastname: null,
            email: null,
            mobile_number: null,
            telephone_number: null,
            address: null,
            iban_number: null,
            bic_swift_number: null,
            account_number: null,
            sort_code: null,
            bank_name: null,
          },
          errors: null
        }
      },
      components: {
        TourManagerFields,
        Errors
      },
      methods: {
        createTourManager () {
            this.$store.dispatch('setLoadStatus')
            
            fetch(this.$api + 'tour-managers/create', {
                method: 'POST',
                body: JSON.stringify(this.tour_manage),
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                this.errors = response.errors
                if(response.status) {
                    this.$router.push({ name: 'tour-manager'})
                    this.$notify({
                        type: 'success',
                        title: response.message
                    });
                } else if (response.errors) {
                    this.$notify({
                        type: 'error',
                        title: response.message
                    });
                }
                this.$store.dispatch('setLoadStatus')
            });
        }
      }
    }
    </script>
    